import React, { Component } from "react";
import { connect } from "react-redux";
import { Tabs, Tab } from "material-ui/Tabs";
import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";

import EditIcon from "material-ui/svg-icons/editor/mode-edit";
import TextIcon from "material-ui/svg-icons/action/description";
import PinIcon from "material-ui/svg-icons/maps/pin-drop";
import OptionIcon from "material-ui/svg-icons/action/settings-applications";
import PhotoIcon from "material-ui/svg-icons/image/photo";
import RoomIcon from "material-ui/svg-icons/editor/border-all";

import GlobalConfig from "./GlobalConfig";
import SpecificConfig from "./SpecificConfig";
import AccomodationGeolocation from "./AccomodationGeolocation";
import AccomodationOptions from "./AccomodationOptions";
import AccomodationImages from "./AccomodationImages";
import AccomodationRooms from "./AccomodationRooms";
import AccomodationMealplans from "./AccomodationMealplans";
import { importExistingData, loadConfig, clearConfig } from "./actions";
import { renderMerchantHeaderInfos } from "../utils";

import "../common.css";
import "./Accomodation.css";

class Accomodation extends Component {
  state = {
    apidae: "",
    othyssia: "",
    ospita: "",
    disabled: false
  };

  componentDidMount() {
    this.setState(
      {
        windowWidth:
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth
      },
      this.props.loadConfig(this.props.merchantCode, this.props.lang)
    );
    if (typeof window !== "undefined")
      window.addEventListener("resize", this.onResizeFct, false);
  }

  onResizeFct = () => {
    this.setState({
      windowWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { apidae, othyssia, ospita } = this.props;
    if (prevProps.apidae !== apidae || prevProps.othyssia !== othyssia)
      this.setState({ apidae, othyssia });
    if (prevProps.ospita !== ospita) this.setState({ ospita });
  }

  componentWillUnmount() {
    if (typeof window !== "undefined")
      window.removeEventListener("resize", this.onResizeFct, false);
    this.props.clearConfig();
  }

  renderAccomodationGlobalConfig = () => {
    return <GlobalConfig />;
  };
  renderAccomodationSpecificConfig = () => {
    return <SpecificConfig />;
  };

  renderAccomodationGeolocation = () => {
    return <AccomodationGeolocation />;
  };

  renderAccomodationOptions = () => {
    return <AccomodationOptions />;
  };

  renderAccomodationImages = () => {
    return <AccomodationImages />;
  };

  renderAccomodationRooms = () => {
    return <AccomodationRooms />;
  };

  renderAccomodationMealplans = () => {
    return <AccomodationMealplans />;
  };

  renderAccomodationConfig = () => {
    const { windowWidth } = this.state;
    const displayIcon = windowWidth <= 1000;
    const globalTabProps = {
      label: displayIcon ? undefined : "Configuration",
      icon: displayIcon ? <EditIcon /> : undefined
    };
    const specificTabProps = {
      label: displayIcon ? undefined : "Descriptifs",
      icon: displayIcon ? <TextIcon /> : undefined
    };
    const geolocTabProps = {
      label: displayIcon ? undefined : "Géolocalisation",
      icon: displayIcon ? <PinIcon /> : undefined
    };
    const optionsTabProps = {
      label: displayIcon ? undefined : "Options",
      icon: displayIcon ? <OptionIcon /> : undefined
    };
    const imagesTabProps = {
      label: displayIcon ? undefined : "Images",
      icon: displayIcon ? <PhotoIcon /> : undefined
    };
    const roomsTabProps = {
      label: displayIcon ? undefined : "Chambres",
      icon: displayIcon ? <RoomIcon /> : undefined
    };
    return (
      <Tabs>
        <Tab {...globalTabProps}>{this.renderAccomodationGlobalConfig()}</Tab>
        <Tab {...specificTabProps}>
          {this.renderAccomodationSpecificConfig()}
        </Tab>
        <Tab {...geolocTabProps}>{this.renderAccomodationGeolocation()}</Tab>
        <Tab {...optionsTabProps}>{this.renderAccomodationOptions()}</Tab>
        <Tab {...imagesTabProps}>{this.renderAccomodationImages()}</Tab>
        {this.props.accomodation.source !== "MAEVA" && (
          <Tab {...roomsTabProps}>
            {this.renderAccomodationRooms()}
            {this.renderAccomodationMealplans()}
          </Tab>
        )}
      </Tabs>
    );
  };

  importAccomodationConfig = (fromScratch = true, isMaeva = false) => () => {
    this.setState({ disabled: true });
    this.props.importExistingData(
      this.props.merchantCode,
      this.props.lang,
      !fromScratch ? this.state.apidae : undefined,
      !fromScratch ? this.state.othyssia : undefined,
      !fromScratch ? this.state.ospita : undefined,
      isMaeva
    );
  };

  changeApidaeCode = (e, apidae) => {
    this.setState({ apidae });
  };

  changeOthyssiaCode = (e, othyssia) => {
    this.setState({ othyssia });
  };

  changeOspitaCode = (e, ospita) => {
    this.setState({ ospita });
  };

  renderImportAccomodationConfig = () => {
    const { apidae, othyssia, ospita, disabled } = this.state;
    return (
      <div>
        <div>
          <div className="accomodation-import-text">
            Veuillez rentrer le code Apidae et/ou le code Othyssia de
            l'hébergement et cliquez sur Importer pour créer automatiquement sa
            configuration
          </div>
          <div className="accomodation-import-with-params-block">
            <TextField
              name="apidae"
              value={apidae}
              onChange={this.changeApidaeCode}
              floatingLabelText="Code Apidae"
              style={{ width: "20%" }}
            />
            <TextField
              name="othyssia"
              value={othyssia}
              onChange={this.changeOthyssiaCode}
              floatingLabelText="Code Othyssia"
              style={{ width: "30%" }}
            />
            <RaisedButton
              className="import-config-btn"
              label="Importer"
              secondary
              disabled={disabled}
              onClick={this.importAccomodationConfig(false)}
            />
          </div>
        </div>
        <div className="accomodation-import-maeva">
          <div className="accomodation-import-text">
            Pour un hébergement Maeva veuillez ne saisir que le code Ospita
            ci-dessous
          </div>
          <div className="accomodation-import-with-params-block">
            <TextField
              name="ospita"
              value={ospita}
              onChange={this.changeOspitaCode}
              floatingLabelText="Code Ospita"
              style={{ width: "20%" }}
            />
            <div style={{ width: "30%" }} />
            <RaisedButton
              className="import-config-btn"
              label="Importer"
              secondary
              disabled={disabled}
              onClick={this.importAccomodationConfig(false, true)}
            />
          </div>
        </div>
        <div className="accomodation-import-empty-block">
          <div className="accomodation-import-text">
            Pour créer une configuration manuellement, veuillez cliquer sur le
            bouton ci-dessous
          </div>
          <RaisedButton
            className="init-config-btn"
            label="Initialiser"
            secondary
            disabled={disabled}
            onClick={this.importAccomodationConfig(true)}
          />
        </div>
      </div>
    );
  };

  render() {
    const { isAdmin, merchantLibelle, mainResortLibelle } = this.props;
    const accomodationConfigExists =
      this.props.accomodation !== undefined &&
      this.props.accomodation.id !== undefined;
    return !accomodationConfigExists ? (
      <div className="card-container">
        <div className="card">
          {renderMerchantHeaderInfos(
            isAdmin,
            merchantLibelle,
            mainResortLibelle
          )}
          <div className="title">Gestion des informations Hébergement</div>
          <div className="inner">{this.renderImportAccomodationConfig()}</div>
        </div>
      </div>
    ) : (
      this.renderAccomodationConfig()
    );
  }
}

/********* Container part */

const mapStateToProps = state => ({
  merchantCode: state.merchant.detail.code,
  merchantLibelle: state.merchant.detail.libelle,
  mainResortLibelle: state.merchant.detail.mainResortLibelle,
  isAdmin: state.app.auth.user.isAdmin,
  accomodation: state.accomodation,
  lang: state.accomodation.lang,
  apidae: state.accomodation.apidae,
  othyssia: state.accomodation.othyssia,
  ospita: state.accomodation.ospita
});

const mapDispatchToProps = dispatch => ({
  loadConfig: (code, lang) => {
    dispatch(loadConfig(code, lang));
  },
  importExistingData: (code, lang, apidae, othyssia, ospita, isMaeva) => {
    dispatch(importExistingData(code, lang, apidae, othyssia, ospita, isMaeva));
  },
  clearConfig: () => {
    dispatch(clearConfig());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Accomodation);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/Accomodation.js